export const GET_AVAIL_PLAN_YEARS_QUERY_KEY = 'get_available_plan_years';
